export const formatToCompactNumber = (value: number | string, decimals = 1) => {
	const parsedValue = typeof value === 'string' ? Number(value) : value;

	if (parsedValue > 1000000000) {
		return `${(parsedValue / 1000000000).toFixed(decimals)}G`;
	} else if (parsedValue > 1000000) {
		return `${(parsedValue / 1000000).toFixed(decimals)}M`;
	} else if (parsedValue > 1000) {
		return `${(parsedValue / 1000).toFixed(decimals)}K`;
	} else {
		return `${parsedValue.toFixed(2)}`;
	}
};
